module.exports = __webpack_public_path__ + "img/educator_5-8.1463b45f.png";